import { ArrowRight, CheckCircle, Sparkles } from "lucide-react";

const Header = ({ scrollToSection }) => {
  return (
    <section className="pt-32 pb-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-4xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-100/60 backdrop-blur rounded-full text-blue-700 text-sm font-semibold mb-6 border border-blue-200/60">
            <Sparkles className="w-4 h-4" />
            <span>Interfaz diseñada por dentistas, para dentistas</span>
          </div>

          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-slate-900 mb-6 leading-tight">
            Tu consultorio,
            <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              {" "}
              100% organizado
            </span>
          </h1>

          <p className="text-xl sm:text-2xl text-slate-600 mb-8 leading-relaxed">
            Agenda digital, historiales de pacientes y control financiero.
            <br className="hidden sm:block" />
            <span className="font-semibold text-slate-700">
              Todo en un solo lugar.
            </span>
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <a
              href="/registrarse"
              className="px-8 py-4 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl font-semibold text-lg hover:from-blue-700 hover:to-blue-800 transition-all shadow-2xl shadow-blue-600/40 hover:shadow-blue-600/60 hover:scale-105 flex items-center gap-2"
            >
              Prueba gratis 30 días
              <ArrowRight className="w-5 h-5" />
            </a>
            <button
              onClick={() => scrollToSection("features")}
              className="px-8 py-4 bg-white text-slate-700 rounded-xl font-semibold text-lg hover:bg-slate-50 transition-all shadow-lg border border-slate-200 hover:scale-105"
            >
              Ver cómo funciona
            </button>
          </div>

          {/* Value Props */}
          <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-12 text-sm">
            <div className="flex items-center gap-2 text-slate-600">
              <CheckCircle className="w-5 h-5 text-emerald-500" />
              <span className="font-medium">30 días gratis</span>
            </div>
            <div className="flex items-center gap-2 text-slate-600">
              <CheckCircle className="w-5 h-5 text-emerald-500" />
              <span className="font-medium">Sin tarjeta de crédito</span>
            </div>
            <div className="flex items-center gap-2 text-slate-600">
              <CheckCircle className="w-5 h-5 text-emerald-500" />
              <span className="font-medium">Cancela cuando quieras</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Header;
